'use strict';

angular.module('membership')
  .controller('LoginCtrl', ['$scope', 'loginViewModel', function ($scope, loginViewModel) {
    $scope.viewModel = new loginViewModel();
  }]);